// import { useState } from "react";

export default function FooterComponent() {
  return (
    <div className="footer-text">
      Copyright © Avalon Admission 2024. All rights reserved.
    </div>
  );
}